//@ts-ignore
import { ref } from 'vue'


export const deferredPrompt = ref<Event | null>(null)
// In main.js or App.vue
if (typeof window !== 'undefined') {
    window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault()
        deferredPrompt.value = e
        console.log('[Global] beforeinstallprompt event captured')
    })
}